import React, { ReactElement } from 'react';
import { observer } from 'mobx-react-lite';
import { LoginNotifications } from '../LoginNotifications';

interface NotificationsBufferProps {}

let NotificationsBuffer = function ({}: NotificationsBufferProps): ReactElement {
  return (
    <>
      <LoginNotifications />
    </>
  );
};

NotificationsBuffer = observer(NotificationsBuffer);

export { type NotificationsBufferProps, NotificationsBuffer };
